import React from 'react';
import { useAuth } from '../context/AuthContext';
import Login from './Login';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="portal" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="portal-spinner" />
      </div>
    );
  }
  if (!user) return <Login />;
  return children;
};

export default ProtectedRoute;
